//Questions and Answers for QA page
const QandA = [
  {
    text: "What year was the first Star Wars movie released?",
    answer: "1977",
  },
  {
    text: "Who created the Star Wars universe?",
    answer: "George Lucas",
  },
  {
    text: "What is the name of the Jedi master who trained Luke Skywalker?",
    answer: "Obi-Wan Kenobi",
  },
  {
    text: "What is the name of the furry creatures who live on the forest moon of Endor?",
    answer: "Ewoks",
  },
  {
    text: "Who is the main villain in the Star Wars original trilogy?",
    answer: "Darth Vader",
  },
  {
    text: "What is the name of Han Solo's ship?",
    answer: "Millennium Falcon",
  },
  {
    text: "What is the name of the planet that is home to the Jedi Temple?",
    answer: "Coruscant",
  },
  {
    text: "What is the name of the bounty hunter who captures Han Solo in The Empire Strikes Back?",
    answer: "Boba Fett",
  },
  {
    text: "What is the name of the weapon that the Empire uses to destroy planets?",
    answer: "Death Star",
  },
  {
    text: "Who is the creator of the Force?",
    answer: "Unknown",
  },
];

export default QandA;
